/**
 * Secure token management.
 * Uses sessionStorage (tab-scoped, cleared on close) instead of localStorage.
 * Includes basic JWT expiry validation.
 */

const TOKEN_KEY = 'admin_token';

function parseJwt(token) {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64).split('').map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')
    );
    return JSON.parse(jsonPayload);
  } catch {
    return null;
  }
}

export function getToken() {
  const token = sessionStorage.getItem(TOKEN_KEY);
  if (!token) return null;

  // Check expiry
  const payload = parseJwt(token);
  if (payload && payload.exp) {
    const now = Math.floor(Date.now() / 1000);
    if (payload.exp < now) {
      sessionStorage.removeItem(TOKEN_KEY);
      return null;
    }
  }
  return token;
}

export function setToken(token) {
  sessionStorage.setItem(TOKEN_KEY, token);
}

export function clearToken() {
  sessionStorage.removeItem(TOKEN_KEY);
}

export function isAuthenticated() {
  return getToken() !== null;
}
